import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http'; 
import { FormComponent } from './components/form/form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { Base64Pipe } from './pipes/base64.pipe';
import { SimpleTextPipe } from './pipes/simple-text.pipe';
import { StringJSONPipe } from './pipes/string-json.pipe';

@NgModule({
  declarations: [
    AppComponent,
    FormComponent,
    Base64Pipe,
    SimpleTextPipe,
    StringJSONPipe
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    ReactiveFormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { } 
